export class HoraBloqueoClientes {
        id: string;
        fechaAnterior: string;
        fechaActual: string;
        motivo: string;
        lastUpdated: string;
}